import React, { useState } from 'react';
import { FiChevronDown, FiChevronRight, FiCopy, FiCheck } from 'react-icons/fi';
import { CommandStep } from '../../../../../types/flow';
import { cn } from '../lib/utils';

interface RawCommandPreviewProps {
  commands: CommandStep[];
}

export function RawCommandPreview({ commands }: RawCommandPreviewProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [copied, setCopied] = useState(false);

  const rawJson = JSON.stringify(
    commands.map(cmd => {
      if (cmd.type === 'sleep') return { sleep: cmd.duration };
      if (cmd.type === 'event') return { event: cmd.event };
      if (cmd.type === 'video') return { video: cmd.options || {} };
      if (cmd.type === 'mock-command') return { substitute: cmd.substitute };
      return {
        command: cmd.command,
        ...(cmd.label ? { alias: cmd.label } : {}),
        ...(typeof cmd.sleep === 'number' ? { sleep: cmd.sleep } : {}),
        ...(typeof cmd.timeout === 'number' ? { timeout: cmd.timeout } : {}),
      };
    }),
    null,
    2,
  );

  const handleCopy = async () => {
    await navigator.clipboard.writeText(rawJson);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="adslot-preview">
      <div
        role="button"
        tabIndex={0}
        onClick={() => setIsExpanded(!isExpanded)}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setIsExpanded(prev => !prev);
          }
        }}
        className="adslot-preview-header"
      >
        <div className="adslot-preview-header-left">
          {isExpanded ? (
            <FiChevronDown className="adslot-icon-xs" />
          ) : (
            <FiChevronRight className="adslot-icon-xs" />
          )}
          <span className="adslot-preview-title">Raw Command Preview</span>
          <span className="adslot-preview-subtitle">(read-only)</span>
        </div>

        <button
          type="button"
          onClick={e => {
            e.stopPropagation();
            handleCopy();
          }}
          className={cn(
            'adslot-preview-copy-btn',
            copied && 'adslot-preview-copy-btn-success',
          )}
        >
          {copied ? (
            <>
              <FiCheck className="adslot-icon-xs" />
              Copied
            </>
          ) : (
            <>
              <FiCopy className="adslot-icon-xs" />
              Copy
            </>
          )}
        </button>
      </div>

      {isExpanded && (
        <div className="adslot-preview-body">
          <pre className="adslot-preview-code">
            {commands.length === 0 ? (
              <span className="adslot-preview-placeholder">
                // No commands added yet
              </span>
            ) : (
              rawJson
            )}
          </pre>
        </div>
      )}
    </div>
  );
}
